import { Component, Injectable, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { IdentifierService } from './identifier.service';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { IOption } from 'ng-select';
import { ActivatedRoute, Params } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { EvsProductService } from '../../../../common/services/EvsProduct.service';
import { StampStatisticsService } from '../statistics/StampStatistics.service';
import { ImageService } from '../../../imageService';
import { ExportService } from '../../../../common/services/Export.service';
import { ToastrService } from 'ngx-toastr';

import { TranslateService } from '@ngx-translate/core';

declare var $: any;
let that;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'log_identifier',
  templateUrl: './log-identifier-list-detail.template.html',
  styleUrls: ['./log-identifier.component.css'],
  providers: [EvsProductService, StampStatisticsService],
})
@Injectable()
export class Log_identifierComponent implements OnInit {
  page_title = '';
  no_image = 'assets/images/no_product.gif';

  // config service
  code_chonggia = 1;
  code_baohanh = 2;
  code_tranhang = 3;
  code_dinhdanh = 5;

  public current_filter: any = {};
  public message: { content: string; alert_type: string } = null;
  public list_items: any = [];
  has_list = true;
  public item_detail: any;
  public item_active = 0;
  loadingDetail = false;

  list_responses: Array<IOption> = [];
  list_types: Array<IOption> = [];

  Infinity = Infinity;

  // list_cities:any={};
  list_cities_filter: Array<IOption> = [];
  list_products: Array<IOption> = [];
  list_district_by_city: Array<IOption> = [];
  has_list_districts = false;
  public FormFilterLogsChongGia: FormGroup;

  pager: any;
  currentPage = 1;
  page_size = 10;
  totalRow = 0;
  isSorting: any = {};
  overview = {
    identity_qri_scan: 0,
    identity_qrm_scan: 0,
    identity_sms_scan: 0,
    identity_stamps: 0,
    identity_total_scan: 0
  };
  waitPage = false;
  showMoreFilter = true;
  /***Tuanba:17-11-2022: Thay api xuất báo cáo **/
  public messageExport = '';
  // tslint:disable-next-line:member-ordering
  productId: any = null;

  constructor(
    private logsService: IdentifierService,
    private addressService: EvsAddressService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private productService: EvsProductService,
    private stampStatistic: StampStatisticsService,
    private imageService: ImageService,
    private exportService: ExportService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    that = this;
    this.FormFilterLogsChongGia = fb.group({
      response: [null],
      scan_time_ranger: [null],
      type: [null],
      serial: [null],
      city_id: [null],
      district_id: [null],
      product_id: [null],
    });
    this.item_detail = undefined;

    this.translate.onLangChange.subscribe(() => {
      this.updateTranslations();
    });
  }

  updateTranslations() {
    this.translate.get('LICH_SU_QUET_TEM_INH_DANH').subscribe((res: string) => {
      this.page_title = res;
    });

    this.list_responses = [
      { value: 'active', label: this.translate.instant('XAC_THUC') },
      { value: 'warning', label: this.translate.instant('CANH_BAO') },
    ];
    this.list_types = [
      { value: 'qrm', label: this.translate.instant('QUET_MA_HO') },
      { value: 'qri', label: this.translate.instant('QUET_MA_PHU_CAO') },
      { value: 'sms', label: this.translate.instant('NHAN_TIN_SMS') },
    ];

    setTimeout(() => {
      $('#product_id').select2({ placeholder: this.translate.instant('SAN_PHAM'), allowClear: false });
      $('#response').select2({
        placeholder: this.translate.instant('TRANG_THAI_QUET'),
        allowClear: false,
        minimumResultsForSearch: -1,
      });
      $('#type').select2({
        placeholder: this.translate.instant('KIEU_QUET'),
        allowClear: false,
        minimumResultsForSearch: -1,
      });
      $('#city_id').select2({ placeholder: this.translate.instant('TINH_TP'), allowClear: false });
      $('#district_id').select2({ placeholder: this.translate.instant('QUAN_HUYEN'), allowClear: false });
      $(".slt-batchstamp").select2({
        placeholder: this.translate.instant('TIM_KIEM_LO_TEM'),
        allowClear: true,
        minimumInputLength: 2,
        ajax: {
          delay: 1000,
          url: `${environment.api_evs}/batches`,
          headers: {
            authorization: `${localStorage.getItem("Access-Token")}`,
            "Content-Type": "application/json",
          },
          dataType: "json",
          data: function (params) {
            $(".select2-container").addClass("setIndex-1800");
            if (params.term) {
              return {
                name: params.term,
                offset: 0,
                limit: 150,
                show_parent_child: 1,
              };
            }
            return {
              offset: 0,
              limit: 150,
              show_parent_child: 1,
            };
          },
          processResults: function (data) {
            return {
              results:
                data.data && data.data.batches
                  ? data.data.batches.map((item) => {
                    return {
                      text: item.name,
                      id: item.id,
                    };
                  })
                  : [],
            };
          },
        },
      });
    }, 200);
  }

  getOverView() {
    this.logsService
      .getOverviewData()
      .toPromise()
      .then((res: any) => {
        this.overview = res.data;
        // console.log('res', res.data)
      })
      .catch((err: any) => {
      });
  }



  // getOverView() {
  //   this.stampStatistic
  //     .getDashboardOverview()
  //     .toPromise()
  //     .then((res: any) => {
  //       if (res.error == false) {
  //         // this.overview = {
  //         //   verify_turn: res.data.verify_turn,
  //         //   stamps_verify: res.data.stamps_verify,
  //         //   warning_verify: res.data.warning_verify,
  //         //   warning_stamps: res.data.warning_stamps,
  //         // };
  //       } else {
  //         console.log('getDashboardOverview:error', res);
  //       }
  //     })
  //     .catch((err: any) => {
  //       console.log('getDashboardOverview:catch', err);
  //     });
  // }

  filterClick(type) {
    switch (type) {
      case 'verify_turn': {
        $('#product_id').val('').trigger('change');
        $('#response').val('').trigger('change');
        $('#type').val('').trigger('change');
        $('#city_id').val('').trigger('change');
        $('#district_id').val('').trigger('change');
        this.isSorting = 'desc';
        this.list_district_by_city = [];
        this.FormFilterLogsChongGia.reset();
        $('#response').val('active').trigger('change');
        this.onSubmit(this.FormFilterLogsChongGia);
        break;
      }
      case 'stamps_verify': {
        break;
      }
      case 'warning_verify': {
        $('#product_id').val('').trigger('change');
        $('#response').val('').trigger('change');
        $('#type').val('').trigger('change');
        $('#city_id').val('').trigger('change');
        $('#district_id').val('').trigger('change');
        this.isSorting = 'desc';
        this.list_district_by_city = [];
        this.FormFilterLogsChongGia.reset();
        $('#response').val('warning').trigger('change');
        this.onSubmit(this.FormFilterLogsChongGia);
        break;
      }
      case 'warning_stamps': {
        break;
      }
    }
  }

  public loadData(request: any = null, sort: any = {}) {
    this.waitPage = true;
    const data_get: any = request ? request : this.current_filter;
    if (this.currentPage < 0) {
      this.currentPage = 1;
    }
    data_get.offset =
      this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    data_get.limit = this.page_size;
    //data_get.sort_by = this.current_filter.sort_by;
    data_get.service = this.code_chonggia; // filter theo chống giả
    data_get.sort_by = 'ins_dt:' + sort;
    data_get.scan_service_type = 1;
    this.logsService
      .getLogsScan(data_get)
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          const list: any = [];
          for (const _data of res.data) {
            let type_f = '';
            if (_data.type == 'sms') {
              type_f = this.translate.instant('NHAN_TIN_SMS');
            } else if (_data.type == 'qrm') {
              type_f = this.translate.instant('QUET_MA_HO');
            } else if (_data.type == 'qri') {
              type_f = this.translate.instant('QUET_MA_PHU_CAO');
            } else {
              type_f = this.translate.instant('KHONG_XAC_DINH');
            }
            let response_f = '';
            if (_data.response == 'active') {
              response_f = this.translate.instant('XAC_THUC');
            } else if (_data.response == 'warning') {
              response_f = this.translate.instant('CANH_BAO');
            }
            const obj = {
              id: _data._id,
              serial: this.formatSerial(_data.number, _data.prefix),
              city: _data.city,
              type: _data.type,
              type_f: type_f,
              response: _data.response,
              response_f: response_f,
              scan_time: moment(_data.ins_dt).format('DD/MM/YYYY HH:mm:ss'),
              product_image: this.imageService.readSrcImage(
                _data.product_image,
                'thumb_medium'
              ),
              location_by: res.data.location_by,
              location_type_batch: res.data.location_type_batch,
            };
            list.push(obj);
          }
          // console.log(list);
          this.list_items = list;

          this.item_active = 0;
          if (list.length > 0) {
            this.has_list = true;
            this.viewDetail(0);
          } else {
            this.has_list = false;
            this.item_detail = null;
          }
        } else {
        }
        this.waitPage = false;
      })
      .catch((err: any) => {
      });
  }
  public item_detail_loyalty: any;

  sliceSerial(serial) {
    let index = serial.indexOf("-");
    let prefix = serial.substring(0, index);
    let number = serial.substring(index + 1);
    let array = [];
    array.push(prefix, number)
    return array;
  }

  viewDetail(i) {
    this.item_active = i;
    console.log("asdasdasd", this.list_items[i]);
    let params = this.sliceSerial(this.list_items[i].serial);
    console.log("params", params);
    this.logsService
      .getLogsDetailLoyalty(this.list_items[i].id, params[0], params[1])
      .toPromise()
      .then((res: any) => {
        if (res.code === 1) {
          this.item_detail_loyalty = {
            campaignId: res.data.campaign_id,
            campaignName: res.data.campaignName,
            status: res.data.status,
            joinedAt: res.data.joined_at,
            qri: res.data.qri,
            qrcheckScanLog: res.data.qrcheck_scan_log
          };
        } else {
          console.log('getLogsDetailLoyalty:error', res);
        }
      })
      .catch((err) => {
        console.log('getLogsDetailLoyalty:catch:', err);
      });

    this.logsService
      .getLogsDetail(this.list_items[i].id)
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          const arr_services = this.convertServiceToText(res.data.services);
          let diachi = '';
          if (res.data.address) {
            diachi += diachi ? ', ' + res.data.address : res.data.address;
          }
          if (res.data.district_name) {
            diachi += diachi ? ', ' + res.data.district : res.data.district;
          }
          this.item_detail = {
            id: res.data._id,
            serial: this.formatSerial(res.data.number, res.data.prefix),
            qrmMappingCode: res.data.qrmMappingCode,
            product_name: res.data.product_name,
            product_image: this.imageService.readSrcImage(
              res.data.product_image,
              'thumb_medium'
            ),
            code: res.data.code,
            type: res.data.type,
            type_f: this.list_items[i].type_f,
            batch_id: res.data.batch_id,
            batch_name: res.data.batch_name,
            arr_services: arr_services,
            active_time: res.data.active_time,
            active_time_f: moment(res.data.active_time).format('DD/MM/YYYY'),
            response: res.data.response,
            response_f: this.list_items[i].response_f,
            scanner: res.data.scanner,
            device_id: res.data.device_id,
            scan_time: moment(res.data.ins_dt).format('DD/MM/YYYY HH:mm:ss'),
            os: res.data.os,
            diachi: diachi,
            city: res.data.city,
            user_agent: res.data.user_agent,
            location_by: res.data.location_by,
            location_type_batch: res.data.location_type_batch,
          };
        } else {
          console.log('getLogsDetail:error', res);
        }
      })
      .catch((err) => {
        console.log('getLogsDetail:catch:', err);
      });
  }

  ngOnInit() {
    this.updateTranslations();
    $('#city_id').on('select2:select', function (e) {
      const city = e.params.data.id;
      that.listDistricts(city);
    });
    $('#city_id').on('select2:unselect', function (e) {
      that.list_district_by_city = [];
      $('#district_id').val('').trigger('change');
    });
    this.listCities();
    // this.listProducts();
    this.getOverView();
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.isSorting = 'desc';
      if (params.batch_id) {
        this.current_filter.batch_id = params.batch_id;
        $('#batch_id').val(params.batch_id).trigger('change');
        this.current_filter.response = params.response;
        $('#response').val(params.response.to).trigger('change');
        this.loadData(this.current_filter, this.isSorting);
      } else {
        this.loadData(this.current_filter, this.isSorting);
      }
    });


  }

  changeProduct(event) {
    this.productId = event ? event : null;
  }

  onSubmit(data?: any) {
    this.currentPage = 1;
    const data_filter: any = {};
    if ($('#response').val()) {
      data_filter.response = $('#response').val();
    }
    if (data.scan_time_ranger && data.scan_time_ranger.length == 2) {
      data_filter.from = moment(data.scan_time_ranger[0]).format('YYYY-MM-DD');
      data_filter.to = moment(data.scan_time_ranger[1]).format('YYYY-MM-DD');
    }
    if ($('#type').val()) {
      data_filter.type = $('#type').val();
    }
    console.log('$(".slt-batchstamp").val()', $(".slt-batchstamp").val())
    if ($(".slt-batchstamp").val()) {
      data_filter.batch_id = $(".slt-batchstamp").val();
    }

    if (data.serial) {
      data_filter.serial = data.serial;
    }
    if ($('#city_id').val()) {
      data_filter.city_id = $('#city_id').val();
    }
    if ($('#district_id').val()) {
      data_filter.district_id = $('#district_id').val();
    }
    // if ($("#product_id").val()) {
    //   data_filter.product_id = $("#product_id").val();
    // }
    if (this.productId) {
      data_filter.product_id = this.productId;
    }
    this.current_filter = data_filter;
    this.loadData(data_filter, this.isSorting);
  }

  ResetFormSearch() {
    $('#drp-list-product .clear').click();
    $('.slt-batchstamp').val('').trigger('change');
    $('#drp-list-product .clear').click();
    $('#product_id').val('').trigger('change');
    $('#response').val('').trigger('change');
    $('#type').val('').trigger('change');
    $('#city_id').val('').trigger('change');
    $('#district_id').val('').trigger('change');
    this.isSorting = 'desc';
    // this.productId = null;
    this.list_district_by_city = [];
    this.FormFilterLogsChongGia.reset();
    this.onSubmit(this.FormFilterLogsChongGia);
  }

  setSort(typeSort: string) {
    this.currentPage = 1;
    this.isSorting = typeSort;
    this.loadData(null, typeSort);
  }

  // listProducts() {
  //   this.productService
  //     .getProducts({ limit: 500, sort_by: "name:asc" })
  //     .toPromise()
  //     .then((res) => {
  //       if (res.error == false) {
  //         // let list:Array<IOption> = [];
  //         // for(let item of res.data.products){
  //         //     let obj = {value: item.id, label: item.name};
  //         //     list.push(obj);
  //         // }

  //         this.list_products = res.data.products.map((pro, index, products) => {
  //           return { value: pro.id, label: pro.name };
  //         });
  //       } else {
  //         console.log("getAllProduct: error", res);
  //       }
  //     })
  //     .catch((err: any) => {
  //       console.log("getAllProduct:catch", err);
  //     });
  // }

  listCities() {
    this.addressService
      .getCities()
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          const cities = {};
          const cities_filter: Array<IOption> = [];
          for (const city of res.data.cities) {
            cities_filter.push({ value: city.id, label: city.name });
            // cities[city.id] = city.name
          }
          // this.list_cities = cities;
          this.list_cities_filter = cities_filter;
        } else {
          console.log('getCities:error', res);
        }
      })
      .catch((err: any) => {
        console.log('getCities:catch', err);
      });
  }

  listDistricts(city_id) {
    if (city_id && city_id > 0) {
      this.addressService
        .getDistrict({ city_id: city_id })
        .toPromise()
        .then((res: any) => {
          if (res.error == false) {
            this.has_list_districts = true;
            const districts_filter: Array<IOption> = [];
            for (const district of res.data.districts) {
              districts_filter.push({
                value: district.id,
                label: district.name,
              });
            }
            this.list_district_by_city = districts_filter;
          } else {
            console.log('getDistrict:error', res);
          }
        })
        .catch((err: any) => {
          console.log('getDistrict:catch', err);
        });
    }
  }

  deselectedCity() {
    this.has_list_districts = false;
    this.list_district_by_city = [];
  }

  setPage(page: number) {
    if (page < 1) {
      this.currentPage = 1;
      return;
    }
    // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
    if (page !== this.currentPage) {
      this.currentPage = page;
      this.loadData(this.current_filter, this.isSorting);
    }
  }

  goPage(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    } else {
      this.setPage(1); //toPage = 1;
    }
  }

  convertServiceToText(service: string) {
    const arr_services: Array<{ code: number; name: string }> = [];
    if (service.indexOf(this.code_chonggia.toString()) != -1) {
      arr_services.push({ code: this.code_chonggia, name: this.translate.instant('CHONG_GIA') });
    }
    if (service.indexOf(this.code_baohanh.toString()) != -1) {
      arr_services.push({ code: this.code_baohanh, name: this.translate.instant('BAO_HANH') });
    }
    if (service.indexOf(this.code_tranhang.toString()) != -1) {
      arr_services.push({ code: this.code_tranhang, name: this.translate.instant('TRAN_HANG') });
    }
    if (service.indexOf(this.code_dinhdanh.toString()) != -1) {
      arr_services.push({ code: this.code_dinhdanh, name: this.translate.instant('DINH_DANH') });
    }
    return arr_services;
  }

  formatSerial(number, prefix: string = '') {
    let format_serial: string;
    const prefix2 = prefix ? prefix + '-' : '';
    number = number.toString();
    if (number.length > 6) {
      format_serial = prefix2 + number;
    } else {
      const pad = '000000';
      format_serial = prefix2 + pad.substring(0, 6 - number.length) + number;
    }
    return format_serial;
  }

  downloadExcel(data) {
    const data_filter: any = {};

    if ($('#response').val()) {
      data_filter.response = $('#response').val();
    }
    if (data.scan_time_ranger && data.scan_time_ranger.length == 2) {
      data_filter.from = moment(data.scan_time_ranger[0]).format('YYYY-MM-DD');
      data_filter.to = moment(data.scan_time_ranger[1]).format('YYYY-MM-DD');
    }
    if ($('#type').val()) {
      data_filter.type = $('#type').val();
    }
    if (data.serial) {
      data_filter.serial = data.serial;
    }
    if ($('#city_id').val()) {
      data_filter.city_id = $('#city_id').val();
    }
    if ($('#district_id').val()) {
      data_filter.district_id = $('#district_id').val();
    }
    if ($('#product_id').val()) {
      data_filter.product_id = $('#product_id').val();
    }
    this.current_filter = data_filter;
    let url = environment.api_evs + '/logs/scan/identity/excel?';
    if ((data_filter.response = data.response)) {
      url += 'response=' + data_filter.response;
    }
    if (data_filter.from) {
      url += '&from=' + data_filter.from;
    }
    if (data_filter.to) {
      url += '&to=' + data_filter.to;
    }
    if (data_filter.type) {
      url += '&type=' + data_filter.type;
    }
    if (data_filter.serial) {
      url += '&serial=' + data_filter.serial;
    }
    if (data_filter.city_id) {
      url += '&city_id=' + data_filter.city_id;
    }
    if (data_filter.district_id) {
      url += '&district_id=' + data_filter.district_id;
    }

    url += '&sort_by=ins_dt:desc';
    if (localStorage.getItem('Access-Token')) {
      url += '&Access_Token=' + localStorage.getItem('Access-Token');
    }
    location.href = url;
  }

  /***Tuanba:17-11-2022: Thay api xuất báo cáo **/
  exportReport(data) {
    this.messageExport = '';
    $('.stampBoxStampAlertAdd').css('opacity', '0');
    const data_filter: any = {};
    if ($('#response').val()) {
      data_filter.response = $('#response').val();
    }
    if (data.scan_time_ranger && data.scan_time_ranger.length == 2) {
      data_filter.from = moment(data.scan_time_ranger[0]).format('YYYY-MM-DD');
      data_filter.to = moment(data.scan_time_ranger[1]).format('YYYY-MM-DD');
    }
    if ($('#type').val()) {
      data_filter.type = $('#type').val();
    }
    console.log('$(".slt-batchstamp").val()', $('.slt-batchstamp').val())
    if ($('.slt-batchstamp').val()) {
      data_filter.batch_id = $('.slt-batchstamp').val();
    }

    if (data.serial) {
      data_filter.serial = data.serial;
    }
    if ($('#city_id').val()) {
      data_filter.city_id = $('#city_id').val();
    }
    // if ($('#district_id').val()) {
    //   data_filter.district_id = $('#district_id').val();
    // }
    if (this.productId) {
      data_filter.product_id = this.productId;
    }
    data_filter.scan_service_type = 1;
    data_filter.sort = `ins_dt,${this.isSorting}`;
    const body = {
      exportTypeEnum: 'SCAN_LOG_IDENTITY',
      fields: data_filter
    };
    this.exportService.exportReport(body).subscribe((res) => {
      if (res.code == 1) {
        this.messageExport = this.translate.instant('XUAT_FILE_THANH_CONG_VUI_LONG_KIEM_TRA_TRONG_QUAN_LY_BAO_CAO');
        $('.stampBoxStampAlertAdd').css('opacity', '1');
        setTimeout(() => {
          $('.stampBoxStampAlertAdd').css('opacity', '0');
        }, 5000);
      } else {
        $('.stampBoxStampAlertAdd').css('opacity', '0');
        this.toastr.error(res.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
      }
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/identifier/log_identifier.component.ts